import * as React from "react";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

type Size = "small" | "medium";

interface PasswordFieldProps {
  password: string;
  setPassword: (v: string) => void;
  eventsend?: (eventName: string) => void;
  analyticsEvent?: string;          // default: "Password_field_Sign_up-page_clicked"
  placeholder?: string;             // default: "Password"
  size?: Size;                      // default: "small"
  autoComplete?: string;            // default: "new-password" (use "current-password" on login)
  stripWhitespace?: boolean;        // default: false (set true on login to remove spaces)
  minLength?: number;               // optional
}

const PasswordField: React.FC<PasswordFieldProps> = ({
  password,
  setPassword,
  eventsend,
  analyticsEvent = "Password_field_Sign_up-page_clicked",
  placeholder = "Password",
  size = "small",
  autoComplete = "new-password",
  stripWhitespace = false,
  minLength,
}) => {
  const [showPassword, setShowPassword] = React.useState<boolean>(false);

  return (
    <TextField
      id="password-input"
      type={showPassword ? "text" : "password"}
      placeholder={placeholder}
      value={password}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        const raw = e.target.value || "";
        const v = stripWhitespace ? raw.replace(/\s/g, "") : raw;
        setPassword(v);
        eventsend?.(analyticsEvent);
      }}
      fullWidth
      variant="outlined"
      size={size}
      autoComplete={autoComplete}
      inputProps={minLength ? ({ minLength } as React.InputHTMLAttributes<HTMLInputElement>) : undefined}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowPassword((p) => !p)}
              edge="end"
              aria-label="toggle password visibility"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordField;
